// Split.io đã được gỡ bỏ. Chỉ giữ lại danh sách treatment để lớp abstraction
// (split/selectors.ts) tiếp tục trả giá trị fallback tĩnh cho các nơi đang đọc.
export enum TreatmentNames {
  BUYER_WEB_NOTIFICATION = 'BuyerWebNotification',
  BUYER_WEB_HOME_PAGE_POPUP = 'BuyerWebHomePagePopup',
}
